export default {
  creds: null,
  session: {
    access_token: null,
    expires_in: 0,
    refresh_token: null,
  },
  codeChallenge: null,
  sessionAutoRefresh: false,
  sessionExpiration: null,
  impBrokerage: null,
  impUser: null,
  impLoanOffice: null,
  isAuthing: false,
  isReAuthing: false,
  isAuthingBroker: false,
};
